import { c as _c } from "react/compiler-runtime";
import type { AmlDetail } from '@onefootprint/request-types/dashboard';
import { useQueryClient } from '@tanstack/react-query';
import useEntityId from '@/entity/hooks/use-entity-id';
const useCachedRiskSignalAmlHint = riskSignalId => {
  const $ = _c(4);
  const entityId = useEntityId();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== entityId || $[1] !== queryClient || $[2] !== riskSignalId) {
    t0 = queryClient.getQueryData(["entity", entityId, "risk-signals", riskSignalId, "aml-hits"]);
    $[0] = entityId;
    $[1] = queryClient;
    $[2] = riskSignalId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default useCachedRiskSignalAmlHint;